import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import axios from 'axios'

Vue.config.productionTip = false

window.axios = require('axios')
Vue.use(axios)
Vue.prototype.baseURL = 'http://13.126.63.17/u/'
axios.defaults.baseURL = 'http://13.126.63.17/'

Vue.use(BootstrapVue)
new Vue({
  render: h => h(App),
}).$mount('#app')
